import { FIELD_MAX_LENGTHS } from '@/shared/constants';
import { Button, Field } from '@noorden-insurtech/alba-design-system';
import React, { useState } from 'react';
import { ErrorMessage } from './error-message.component';
import { normalizeEmail } from '@/shared/utils/normalize-email.util';

interface ForgotPasswordFormProps {
  onSubmit: (email: string) => Promise<void>;
  loading?: boolean;
  error?: string;
}

export function ForgotPasswordForm({
  onSubmit,
  loading = false,
  error,
}: ForgotPasswordFormProps) {
  const [email, setEmail] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(normalizeEmail(email));
  };

  return (
    <form onSubmit={handleSubmit} className='flex flex-col gap-6 w-full'>
      <Field.Root>
        <Field.Label>E-mail</Field.Label>
        <Field.Input
          type='email'
          value={email}
          onChange={e => setEmail(e.target.value.toLowerCase())}
          placeholder='Digite seu e-mail'
          required
          maxLength={FIELD_MAX_LENGTHS.email}
        />
      </Field.Root>

      {error && <ErrorMessage message={error} />}

      <Button
        type='submit'
        variant='primary'
        size='large'
        disabled={loading}
        className='w-full'
      >
        {loading ? 'Enviando...' : 'Redefinir senha'}
      </Button>
    </form>
  );
}
